document.addEventListener('DOMContentLoaded', () => {
    const detailsSections = document.querySelectorAll('.details-box');

    detailsSections.forEach(section => {
        const list = section.querySelector('.details-btn-content');
        const toggleButton = section.querySelector('.details-btn');

        if (list && toggleButton) {
            const cards = list.querySelectorAll('.details-card');
            const maxCount = parseInt(section.dataset.count, 10) || 3; 
            let totalHeight = 0;

            const calculateMaxHeight = () => {
                if (cards.length > 0) {
                    const parentTop = list.getBoundingClientRect().top;
                    const lastIndex = Math.min(maxCount - 1, cards.length - 1);

                    const lastCardBottom = cards[lastIndex]
                        ? cards[lastIndex].getBoundingClientRect().bottom
                        : parentTop;

                    totalHeight = lastCardBottom - parentTop;

                    if (!list.classList.contains('expanded')) {
                        list.style.maxHeight = `${totalHeight}px`;
                    }
                }
            };

            calculateMaxHeight();
            list.style.overflow = 'hidden';

            toggleButton.addEventListener('click', () => {
                const isActive = list.classList.toggle('expanded');
                toggleButton.classList.toggle('active', isActive);

                if (isActive) {
                    list.style.maxHeight = `${list.scrollHeight}px`;
                } else {
                    calculateMaxHeight();
                    list.style.maxHeight = `${totalHeight}px`;
                }
            });

            window.addEventListener('resize', calculateMaxHeight);
        }
    });
});

